export const TIMESTAMPFORMAT = ['calendar', 'fromNow'];

export const FileSelectMode = {
    Single: 'SINGLE',
    Multiple: 'MULTIPLE',
    Disabled: 'DISABLED'
};
export const FILE_SELECT_MODE = [FileSelectMode.Single, FileSelectMode.Multiple, FileSelectMode.Disabled];